import { render, staticRenderFns } from "./Deserts.vue?vue&type=template&id=51d970c4&"
import script from "./Deserts.vue?vue&type=script&lang=js&"
export * from "./Deserts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports